<app-modal-container [title]="title"
                     [actionButtonName]="'Confirm'"
                     (action)="confirmActivateContactPlan()">
  <div class="pb-2">
    <div class="mb-3">Are you sure you want to {{ action }} this Contact Plan?</div>
    <div>Changes will take effect immediately</div>
  </div>
</app-modal-container>
